import { createFileRoute } from '@tanstack/react-router';
import { LabelsView } from '../../labels/labels-view.js';

export const Route = createFileRoute('/_station/labels')({
  component: LabelsView,
});
